/* eslint-disable dot-notation */
/* eslint-disable consistent-return */

import axios from "axios";
import { toast } from "react-toastify";
import { constant } from '../constant'

// Global interceptor: handle Encompass token expiry
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response?.status === 401 &&
            error.response?.data?.code === 'ENCOMPASS_TOKEN_EXPIRED'
        ) {
            toast.error('Your Encompass session has expired. Please log in again.');
            localStorage.clear();
            window.location.href = '/login';
            return Promise.reject(error); // allow promise chain to complete
        }
        return Promise.reject(error);
    }
);

export const apiget = async (path) => {
    try {
        // eslint-disable-next-line prefer-const
        let response = await axios.get(constant.baseUrl + path, {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        });
        // eslint-disable-next-line dot-notation
        if (response.data.token && response.data.token !== null) {
            // eslint-disable-next-line dot-notation
            localStorage.setItem('token', response.data.token);
        }
        if (response && response.status === 200) {
            toast.success(response.data.message);
        }
        return response;
    } catch (error) {
        console.log('API call failed', error);
        if (error.response) {
            console.log('Response data:', error.response.data);
            console.log('Response status:', error.response.status);
            console.log('Response headers:', error.response.headers);
        }
        
    }
};

export const apigetPublic = async (path) => {
    try {
        // eslint-disable-next-line prefer-const
        let response = await axios.get(constant.baseUrl + path, 
        );
        // eslint-disable-next-line dot-notation
       
       
        return response;
    } catch (error) {
        console.log('API call failed', error);
        if (error.response) {
            console.log('Response data:', error.response.data);
            console.log('Response status:', error.response.status);
            console.log('Response headers:', error.response.headers);
        }
        
    }
};

export const apigetBlob = async (path, accept = 'application/pdf') => {
  try {
    const response = await axios.get(constant.baseUrl + path, {
      responseType: 'blob',
      headers: {
        Accept: accept,
        Authorization: localStorage.getItem('token'), // add token
      },
      withCredentials: true, // if your API uses cookies too
    });
    return response;
  } catch (error) {
    console.log('Blob API call failed', error);
    if (error.response) {
      console.log('Response status:', error.response.status);
      console.log('Response headers:', error.response.headers);
    }
    throw error;
  }
};


export const apiDocusign = async (path, formData) => {
    try {
        // Set the `Content-Type` for multipart/form-data
        const config = {
            headers: {
                'Authorization': localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data', // This is important for file upload
            },
        };

        // Make the POST request with formData
        const response = await axios.post(constant.baseUrl + path, formData, config);

        // Optionally handle the response, e.g., refresh token, show success message
        if (response.data.token && response.data.token !== null) {
            localStorage.setItem('token', response.data.token);
        }

        if (response && response.status === 200) {
            toast.success(response.data.message);
        }

        return response;
    } catch (error) {
        // Error handling, e.g., show error message, handle specific status codes
        if (error && error.response) {
            const errorMessage = error.response.data?.message || 'An error occurred';
            toast.error(errorMessage);
            console.error('apiDocusign Error:', error.response);
        }
        // Optionally, re-throw or return an error object here for further handling
        throw error;
    }
}

export const apipost = async (path, data) => {
    console.log(`Attempting to post to ${path} with data:`, data);

    try {
        console.log('Base URL:', constant.baseUrl);
        console.log('Token:', localStorage.getItem('token'));
        const response = await axios.post(constant.baseUrl + path, data, {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        });
        console.log('Response received:', response);

        if (response.data.token && response.data.token !== null) {
            console.log('New token received, updating localStorage:', response.data.token);
            localStorage.setItem('token', response.data.token);
        }

        if (response && response.status === 200) {
            console.log('Success response:', response.data.message);
            toast.success(response.data.message);
        }

        return response;
    } catch (error) {
        console.error('Error caught in apipost:', error);
        if (error && error.response) {
            console.log('Error response:', error.response);
            if (error.response.data && error.response.status === 401) {
                console.log('Error details:', error.response.data.message);
                if (error.response.data.message) {
                    toast.error(error.response.data.message)
                }
            }
        }
    }
}

export const apipostPublic = async (path, data) => {
    console.log(`Attempting to post to ${path} with data:`, data);

    try {
        console.log('Base URL:', constant.baseUrl);
        console.log('Token:', localStorage.getItem('token'));
        const response = await axios.post(constant.baseUrl + path, data, {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        });
        console.log('Response received:', response);

       

        if (response && response.status === 200) {
            console.log('Success response:', response.data.message);
            toast.success(response.data.message);
        }

        return response;
    } catch (error) {
        console.error('Error caught in apipost:', error);
        if (error && error.response) {
            console.log('Error response:', error.response);
            if (error.response.data && error.response.status === 401) {
                console.log('Error details:', error.response.data.message);
                if (error.response.data.message) {
                    toast.error(error.response.data.message)
                }
            }
        }
    }
}


export const apipostFormData = async (path, formData) => {
    console.log(`Attempting to POST FormData to ${path}`);
  
    try {
      const token = localStorage.getItem('token');
      console.log('Base URL:', constant.baseUrl);
      console.log('Token:', token);
  
      const response = await axios.post(constant.baseUrl + path, formData, {
        headers: {
          'Authorization': token,
          'Content-Type': 'multipart/form-data',
        },
      });
  
      console.log('Response received:', response);
  
      if (response.data.token && response.data.token !== null) {
        console.log('New token received, updating localStorage:', response.data.token);
        localStorage.setItem('token', response.data.token);
      }
  
      if (response && response.status === 200) {
        console.log('Success response:', response.data.message);
        toast.success(response.data.message);
      }
  
      return response;
    } catch (error) {
      console.error('Error caught in apipostFormData:', error);
      if (error && error.response) {
        console.log('Error response:', error.response);
        if (error.response.data && error.response.status === 401) {
          console.log('Error details:', error.response.data.message);
          if (error.response.data.message) {
            toast.error(error.response.data.message);
          }
        } else {
          toast.error('Upload failed. Please try again.');
        }
      }
    }
  };
  
export const apiput = async (path, data) => {
    try {
        const response = await axios.put(constant.baseUrl + path, data, {
            headers: {
                'Authorization': localStorage?.getItem('token')
            }
        });

        if (response.data.token && response.data.token !== null) {
            localStorage.setItem('token', response.data.token);
        }
        if (response && response.status === 200) {
            toast.success(response.data.message);
        }
        return response;
    } catch (error) {
        if (error && error.response) {
            if (error && error.response && error.response.status === 400) {
                if (error.response.data.message) {
                    toast.error(error.response.data.message)
                }
            }
        }
    }
}

export const apiputFormData = async (path, formData) => {
    console.log(`Attempting to POST FormData to ${path}`);
  
    try {
      const token = localStorage.getItem('token');
      console.log('Base URL:', constant.baseUrl);
      console.log('Token:', token);
  
      const response = await axios.put(constant.baseUrl + path, formData, {
        headers: {
          'Authorization': token,
          'Content-Type': 'multipart/form-data',
        },
      });
  
      console.log('Response received:', response);
  
      if (response.data.token && response.data.token !== null) {
        console.log('New token received, updating localStorage:', response.data.token);
        localStorage.setItem('token', response.data.token);
      }
  
      if (response && response.status === 200) {
        console.log('Success response:', response.data.message);
        toast.success(response.data.message);
      }
  
      return response;
    } catch (error) {
      console.error('Error caught in apipostFormData:', error);
      if (error && error.response) {
        console.log('Error response:', error.response);
        if (error.response.data && error.response.status === 401) {
          console.log('Error details:', error.response.data.message);
          if (error.response.data.message) {
            toast.error(error.response.data.message);
          }
        } else {
          toast.error('Upload failed. Please try again.');
        }
      }
    }
  };

export const apidelete = async (path) => {
    try {
        const response = await axios.delete(constant.baseUrl + path, {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        });

        if (response.data.token && response.data.token !== null) {
            localStorage.setItem('token', response.data.token);
        }
        if (response && response.status === 200) {
            toast.success(response.data.message);
        }

        return response;
    } catch (error) {
        if (error && error.response) {
            if (error && error.response && error.response.status === 400) {
                if (error.response.data.message) {
                    toast.error(error.response.data.message)
                }
            }
        }
    }
}

export const deleteManyApi = async (path, data) => {
    try {
        const response = await axios.post(constant.baseUrl + path, data, {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        });
        if (response.data.token && response.data.token !== null) {
            localStorage.setItem('token', response?.data?.token);
        }

        if (response && response.status === 200) {
            toast.success(response.data.message);
        }
        return response;
    } catch (error) {
        if (error && error.response) {
            if (error && error.response.data && error.response.status === 401) {
                if (error.response.data.message) {
                    toast.error(error.response.data.message)
                }
            }
        }
    }
}